var React = require('react');

function Laptop (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ICONS_nieuwwwwww"),React.createElement("path",{"d":"M66.47,13.14a2.14,2.14,0,0,0-3,0l-11,11a2.14,2.14,0,0,0,1.51,3.65,2.17,2.17,0,0,0,1.52-.62l11-11a2.09,2.09,0,0,0,.63-1.51A2.12,2.12,0,0,0,66.47,13.14Z","fill":"#f1b860","key":1}),React.createElement("path",{"d":"M58,11.73h0a2.14,2.14,0,0,0-3,0l-7.52,7.52a2.09,2.09,0,0,0-.63,1.51,2.14,2.14,0,0,0,3.65,1.52L58,14.75A2.14,2.14,0,0,0,58,11.73Z","fill":"#f1b860","key":2}),React.createElement("path",{"d":"M83.84,46h-5.5V7.88A7.9,7.9,0,0,0,70.46,0H15.51A7.9,7.9,0,0,0,7.62,7.88V46H2.77a2.78,2.78,0,0,0-2.08.94A2.81,2.81,0,0,0,0,49.14a7.22,7.22,0,0,0,7.15,6.25h71.6A7.25,7.25,0,0,0,86,48.13,2.16,2.16,0,0,0,83.84,46ZM11.94,7.88a3.57,3.57,0,0,1,3.57-3.56h55A3.57,3.57,0,0,1,74,7.88V46H11.94Z","fill":"#2a2d58","key":3})]);
}

Laptop.defaultProps = {"viewBox":"0 0 86 55.39"};

module.exports = Laptop;

Laptop.default = Laptop;
